import React from "react";
import { SortableTable } from "../../../elements/SortableTable";
import { useNavigate } from "react-router-dom";
import { MdAdd } from "react-icons/md";

export const Developments = () => {

  console.log('Development home');
  const navigate = useNavigate();

  // const { user } = useContext(AuthContext);
  const developments = [
    { name: 'Nombre', property: 'name' },
    { name: 'Ciudad', property: 'city' },
    { name: 'Colonia', property: 'suburb' },
    { name: 'Unidades', property: 'listings', converter: (v: any) => Array.isArray(v) ? v.length : 0},
    { name: 'Actualizado', property: 'updatedAt'}
  ]

  return (
    <>
      <div id="sidebar">
        <h1>Desarrollos</h1>
      </div>
      <div className="section_header">
            <button onClick={()=>navigate('/inventory/developments/new')}>Nuevo Desarrollo <MdAdd /></button>
          </div>
      {/* <div className="">
        <a href="/inventory/developments/new">Agregar Desarrollo</a>
      </div> */}
      <div>
        <SortableTable
          navigation='/inventory/developments/'
          fetchUrl="/inventory/developments"
          columns={developments}
          />
      </div>
    </>
  );
}